import { ActionIcon, Button, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

interface ColorSchemeToggleProps {
  /** Render as a labelled full-width button (for the mobile drawer) instead of an icon. */
  labelled?: boolean;
}

export function ColorSchemeToggle({ labelled = false }: ColorSchemeToggleProps) {
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme('light', { getInitialValueInEffect: true });
  const isDark = computed === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  const icon = isDark ? <IconSun size={18} /> : <IconMoon size={18} />;
  const toggle = () => setColorScheme(isDark ? 'light' : 'dark');

  if (labelled) {
    return (
      <Button variant="subtle" fullWidth justify="flex-start" leftSection={icon} onClick={toggle}>
        {label}
      </Button>
    );
  }

  return (
    <ActionIcon variant="subtle" size="lg" aria-label={label} title={label} onClick={toggle}>
      {icon}
    </ActionIcon>
  );
}
